<template>
  <a
    href="#"
    :style="cssVars"
    @mouseover="hoveron()"
    @mouseout="hoveroff()"
    @click.prevent="$emit('click-swatch', { variant, variantUrl })"
  ><img-yay
     :src="swatchUrl(variant)"
     :alt="`Variant color ${variant.title}`"
     :height="size"
     :width="size"
     onerror="this.style.display = &quot;none&quot;"
   />
    <div
      v-show="showSelector"
      class="selector absolute rounded-full bg-white"
    /></a>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    variant: {
      type: Object,
      required: true,
    },
    size: {
      type: Number,
      default: 16,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click-swatch', 'hoveron', 'hoveroff'],
  data: function () {
    return { hover: false, image: null }
  },
  computed: {
    variantUrl() {
      return `/products/${this.product.handle}?variant=${this.variant.id}`
    },
    cssVars() {
      return {
        '--selector-size': this.size / 2 + 'px',
        '--selector-padding': this.size / 4 + 'px',
      }
    },
    showSelector() {
      return this.hover || this.selected ? true : false
    },
    variantId() {
      return this.variant.id
    },
  },
  methods: {
    handleize(str) {
      return str
        .toLowerCase()
        .replace("'", '')
        .replace(/[^\w\u00C0-\u024f]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    },
    swatchUrl(variant) {
      let handle = variant.title.replace(/\/.+/, '')
      handle = this.handleize(handle)
      return this.fileImgUrl(handle)
    },

    hoveron() {
      this.hover = true
      this.$emit('hoveron', this.variant)
    },
    hoveroff() {
      this.hover = false
      this.$emit('hoveroff', this.variant)
    },
  },
}
</script>

<style scoped>
.selector {
  height: var(--selector-size);
  width: var(--selector-size);
  top: var(--selector-padding);
  left: var(--selector-padding);
}
</style>
